module.exports = __webpack_public_path__ + "media/application/images/svgs/music-f79770adc06173c158570dea5763fd71.svg";